import request from "@/utils/request";

export function fetchList(param) {
  return request({
    url: 'api/console/instance/list',
    method: 'post',
    data: param
  })
}

export function deleteList(param) {
  return request({
    url: 'api/console/instance/release/immediate',
    method: 'post',
    data: param
  })
}

export function fetchtemplateList(param) {
  return request({
    url: 'api/console/parameter/template/query/one',
    method: 'post',
    data: param
  })
}

export function templateSet(param) {
  return request({
    url: 'api/console/instance/set/template',
    method: 'post',
    data: param
  })
}

export function fetchConfigList(param) {
  return request({
    url: 'api/console/parameter/setting/list',
    method: 'post',
    data: param
  })
}

export function updateConfig(param) {
  return request({
    url: 'api/console/parameter/setting/update',
    method: 'post',
    data: param
  })
}

export function fetchDetail(param) {
  return request({
    url: 'api/console/instance/query/one',
    method: 'post',
    data: param
  })
}

export function restart(param) {
  return request({
    url: 'api/console/instance/restart',
    method: 'post',
    data: param
  })
}

export function statistics(param) {
  return request({
    url: 'api/console/instance/statistics',
    method: 'post',
    data: param
  })
}

export function slaveStatus(param) {
  return request({
    url: 'api/console/instance/slave/status',
    method: 'post',
    data: param
  })
}

export function operation(param) {
  return request({
    url: 'api/console/operation/list',
    method: 'post',
    data: param
  })
}

export function upload(param) {
  return request({
    url: 'api/console/instance/upload',
    method: 'post',
    data: param
  })
}

export function dataImport(param) {
  return request({
    url: 'api/console/instance/import',
    method: 'post',
    data: param
  })
}

export function dbCharset(param) {
  return request({
    url: 'api/console/instance/db/charset',
    method: 'post',
    data: param
  })
}

export function dbCreat(param) {
  return request({
    url: 'api/console/instance/db/create',
    method: 'post',
    data: param
  })
}

export function dblist(param) {
  return request({
    url: 'api/console/instance/db/list',
    method: 'post',
    data: param
  })
}

export function delaySpec(param) {
  return request({
    url: 'api/console/instance/renewal/specification',
    method: 'post',
	data: param
  })
}

export function delayOrder(param) {
  return request({
    url: 'api/console/order/renewal',
    method: 'post',
	data: param
  })
}

export function upgradeSpec(param) {
  return request({
    url: 'api/console/instance/query/upgrade/info',
    method: 'post',
	data: param
  })
}

export function upgradePrice(param) {
  return request({
    url: 'api/console/instance/price/difference',
    method: 'post',
	data: param
  })
}

export function upgradeOrder(param) {
  return request({
    url: 'api/console/instance/upgrade',
    method: 'post',
	data: param
  })
}

export function autoRenewalSubmit(param) {
  return request({
    url: 'api/console/instance/turn/on/automatic/renewal',
    method: 'post',
	data: param
  })
}

export function adminPwdReset(param) {
  return request({
    url: 'api/console/instance/reset/password',
    method: 'post',
	data: param
  })
}

export function bandwidthPrice(param) {
  return request({
    url: 'api/console/outnet/price',
    method: 'post',
	data: param
  })
}

export function bandwidthOpen(param) {
  return request({
    url: 'api/console/outnet/buy',
    method: 'post',
	data: param
  })
}
